/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GuaranteeDto } from './GuaranteeDto';
import {
    GuaranteeDtoFromJSON,
    GuaranteeDtoFromJSONTyped,
    GuaranteeDtoToJSON,
    GuaranteeDtoToJSONTyped,
} from './GuaranteeDto';
import type { FormulasContextDto } from './FormulasContextDto';
import {
    FormulasContextDtoFromJSON,
    FormulasContextDtoFromJSONTyped,
    FormulasContextDtoToJSON,
    FormulasContextDtoToJSONTyped,
} from './FormulasContextDto';
import type { ContractFunnelDto } from './ContractFunnelDto';
import {
    ContractFunnelDtoFromJSON,
    ContractFunnelDtoFromJSONTyped,
    ContractFunnelDtoToJSON,
    ContractFunnelDtoToJSONTyped,
} from './ContractFunnelDto';
import type { PricingModeEnum } from './PricingModeEnum';
import {
    PricingModeEnumFromJSON,
    PricingModeEnumFromJSONTyped,
    PricingModeEnumToJSON,
    PricingModeEnumToJSONTyped,
} from './PricingModeEnum';
import type { SidebarComponentDto } from './SidebarComponentDto';
import {
    SidebarComponentDtoFromJSON,
    SidebarComponentDtoFromJSONTyped,
    SidebarComponentDtoToJSON,
    SidebarComponentDtoToJSONTyped,
} from './SidebarComponentDto';

/**
 * Response containing tunnels information for simulation with flat structure
 * @export
 * @interface ContractFunnelsResponse
 */
export interface ContractFunnelsResponse {
    /**
     * 
     * @type {Array<ContractFunnelDto>}
     * @memberof ContractFunnelsResponse
     */
    contractFunnels?: Array<ContractFunnelDto>;
    /**
     * 
     * @type {Array<GuaranteeDto>}
     * @memberof ContractFunnelsResponse
     */
    guarantees?: Array<GuaranteeDto>;
    /**
     * 
     * @type {Array<SidebarComponentDto>}
     * @memberof ContractFunnelsResponse
     */
    sidebar?: Array<SidebarComponentDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractFunnelsResponse
     */
    warningMessages?: Array<string>;
    /**
     * 
     * @type {PricingModeEnum}
     * @memberof ContractFunnelsResponse
     */
    mode?: PricingModeEnum;
    /**
     * One card per fixed formula, priced with all its guarantees, without score.
     * @type {Array<ContractFunnelDto>}
     * @memberof ContractFunnelsResponse
     */
    formulas?: Array<ContractFunnelDto>;
    /**
     * The file's person as the formula cards need it; absent when the mode is classic.
     * @type {FormulasContextDto}
     * @memberof ContractFunnelsResponse
     */
    formulasContext?: FormulasContextDto | null;
}



/**
 * Check if a given object implements the ContractFunnelsResponse interface.
 */
export function instanceOfContractFunnelsResponse(value: object): value is ContractFunnelsResponse {
    return true;
}

export function ContractFunnelsResponseFromJSON(json: any): ContractFunnelsResponse {
    return ContractFunnelsResponseFromJSONTyped(json, false);
}

export function ContractFunnelsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractFunnelsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'contractFunnels': json['contractFunnels'] == null ? undefined : ((json['contractFunnels'] as Array<any>).map(ContractFunnelDtoFromJSON)),
        'guarantees': json['guarantees'] == null ? undefined : ((json['guarantees'] as Array<any>).map(GuaranteeDtoFromJSON)),
        'sidebar': json['sidebar'] == null ? undefined : ((json['sidebar'] as Array<any>).map(SidebarComponentDtoFromJSON)),
        'warningMessages': json['warningMessages'] == null ? undefined : json['warningMessages'],
        'mode': json['mode'] == null ? undefined : PricingModeEnumFromJSON(json['mode']),
        'formulas': json['formulas'] == null ? undefined : ((json['formulas'] as Array<any>).map(ContractFunnelDtoFromJSON)),
        'formulasContext': json['formulasContext'] == null ? undefined : FormulasContextDtoFromJSON(json['formulasContext']),
    };
}

export function ContractFunnelsResponseToJSON(json: any): ContractFunnelsResponse {
    return ContractFunnelsResponseToJSONTyped(json, false);
}

export function ContractFunnelsResponseToJSONTyped(value?: ContractFunnelsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contractFunnels': value['contractFunnels'] == null ? undefined : ((value['contractFunnels'] as Array<any>).map(ContractFunnelDtoToJSON)),
        'guarantees': value['guarantees'] == null ? undefined : ((value['guarantees'] as Array<any>).map(GuaranteeDtoToJSON)),
        'sidebar': value['sidebar'] == null ? undefined : ((value['sidebar'] as Array<any>).map(SidebarComponentDtoToJSON)),
        'warningMessages': value['warningMessages'],
        'mode': PricingModeEnumToJSON(value['mode']),
        'formulas': value['formulas'] == null ? undefined : ((value['formulas'] as Array<any>).map(ContractFunnelDtoToJSON)),
        'formulasContext': FormulasContextDtoToJSON(value['formulasContext']),
    };
}

